import { call, put, takeEvery } from 'redux-saga/effects';
import { businessEntityActionCreators, BusinessEntityActionKeys, FetchBeMinDetails } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { fetchBeMinDetails } from '../businessEntityApi';
import { IBusinessEntityMinDetails } from '../businessEntityInterfaces';

function* fetchBeMinDetailsSaga(action: FetchBeMinDetails) {
  const response: IApiExecuteRespone<IBusinessEntityMinDetails> = yield call(
    fetchBeMinDetails,
    action.payload.businessEntityId
  );

  if (response.value) {
    yield put(businessEntityActionCreators.setMinDetails(response.value));
  }
}

export function* watchFetchBeMinDetails() {
  yield takeEvery(BusinessEntityActionKeys.FETCH_BE_MIN_DETAILS, fetchBeMinDetailsSaga);
}
